import React from "react";
import { Component } from "react";
import {
  Dimensions,
  View,
  Image,
  Text,
  TouchableOpacity,
  TextInput,
  Animated,
  SafeAreaView,
  ImageBackground,
  Platform,
  Keyboard,
} from "react-native";
// import io from "socket.io-client";
import HocComponent from "../../commonComponents/Hoc";
import styles from "../../styles/styles";
let deviceWidth = Dimensions.get("window").width;
import chatstyles from "../../styles/chatStyles";
import ChatContainer from "../../commonComponents/Chats";
import {
  connectToSocket,
  disconnectSocket,
  sendMessage,
} from "../../services/socket/customer-service";
import {
  SESSION_EXPIRY,
  SOCKET_EVENTS,
  TYPE_PLACEHOLDER,
} from "../../constants/textConstants";
import { LinearGradient } from "expo-linear-gradient";
import TermsModel from "../../commonComponents/TermsModel";
import { ANNUAL_PAYMENT, MONTHLY_PAYMENT } from "../../constants/routePaths";
import { decrypt } from "../../utils/encryption";

let backSpaceEntered = false;
let speachrecognitionflag = true;
let SpeechRecognition;
let SpeechGrammarList;
let recognition;
if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
  // speech recognition API supported
  SpeechRecognition =
    window.webkitSpeechRecognition || window.SpeechRecognition;
  SpeechGrammarList =
    window.SpeechGrammarList || window.webkitSpeechGrammarList;
  recognition = new SpeechRecognition();
} else {
  // speech recognition API not supported
  speachrecognitionflag = false;
  //alert("your browser doesnot support voice recognition: switch to chrome")
}

let socket;

class Home extends Component {
  constructor(props) {
    super(props);
    this.inputTextFocus = React.createRef();
    this.keyboardHeight = new Animated.Value(0);
    this.state = {
      chatScreenFlag: false,
      messages: [],
      isAgentTyping: false,
      isAgentConnected: false,
      enteredMessage: "",
      voiceinputrecording: false,
      voiceMessage: "",
      customerId: "",
      isFormatMobileNumber: false,
      showTerms: false,
      inputTextDisabled: true,
      disableOptions: true,
    };
  }

  //initiate socket connection and chat
  initiateChat = async (customerId) => {
    Keyboard.dismiss();
    disconnectSocket();
    socket = connectToSocket(customerId);
    await this.setState({
      messages: [],
      isAgentTyping: false,
      isAgentConnected: false,
      enteredMessage: "",
      voiceinputrecording: false,
      voiceMessage: "",
      isFormatMobileNumber: false,
      showTerms: false,
      customerId: "",
      inputTextDisabled: true,
    });

    socket.on("connect", () => {
      this.setState({
        customerId: socket.id,
      });
    });

    //on unauthenticated tokens
    socket.on(SOCKET_EVENTS.CONNECT_ERROR, () => {
      alert(SESSION_EXPIRY);
      socket.disconnect();
      this.setState({
        chatScreenFlag: false,
      });
    });

    this.listenToMessages(socket);
    this.listenToTyping(socket);
    this.listenToAgentConnection(socket);
  };

  //redirect to other page
  redirect(webUrl, mobileUrl, encryptedData) {
    if (Platform.OS === "web") {
      const win = window.open(`${webUrl}?data=${encryptedData}`, "_blank");
      if (win != "null") win.focus();
    } else {
      this.props.navigation.navigate(mobileUrl, {
        data: encryptedData,
      });
    }
  }

  //listen to messages from socket
  listenToMessages = async (socketClient) => {
    socketClient.on(SOCKET_EVENTS.RECEIVE_MESSAGE, (data) => {
      let inputTextDisabled = false;
      //for formatting mobile number
      if (data.formatMobileNumber) {
        this.setState({ isFormatMobileNumber: true, enteredMessage: "+44-" });
      }

      //for disabling text field on agent handoff
      if (data.type == "agent_handoff") {
        inputTextDisabled = true;
      }
      //for payment redirection
      if (data.link && data.link.type) {
        switch (data.link.type) {
          case "annual_payment":
            inputTextDisabled = true;
            this.redirect(
              data.link.redirectionUrl,
              ANNUAL_PAYMENT,
              data.link.data
            );
            break;
          case "monthly_payment":
            inputTextDisabled = true;
            this.redirect(
              data.link.redirectionUrl,
              MONTHLY_PAYMENT,
              data.link.data
            );
            break;
          // case "terms":
          //   inputTextDisabled = true;
          //   break;
        }
      }

      //end of chat
      if (data.closeChat) {
        inputTextDisabled = true;
      }

      this.setState({
        messages: [...this.state.messages, data],
        inputTextDisabled,
        disableOptions: false,
      });
    });
  };

  //listen to agent connection from socket
  listenToAgentConnection = (socketClient) => {
    socketClient.on(SOCKET_EVENTS.AGENT_CONNECTION, (connectionFlag) => {
      this.setState({
        isAgentConnected: connectionFlag,
      });
    });
  };

  //listen to typing event from operator
  listenToTyping = (socketClient) => {
    socketClient.on(SOCKET_EVENTS.AGENT_TYPING, (typingFlag) => {
      this.setState({
        isAgentTyping: typingFlag,
      });
    });
  };

  //send message fron input
  sendMessageFromInput = () => {
    if (this.state.isFormatMobileNumber) {
      this.setState({ isFormatMobileNumber: false });
    }
    if (this.state.enteredMessage) {
      this.updateSentMessage(this.state.enteredMessage);
      Keyboard.dismiss();
    }
    if (Platform.OS === "web" && deviceWidth >= 1200) {
      this.inputTextFocus.focus();
    }
  };

  //update messages and send to socket
  updateSentMessage = (value) => {
    const messageObj = sendMessage(value);
    this.setState({
      messages: [...this.state.messages, messageObj],
      enteredMessage: "",
      disableOptions: true,
    });
  };

  //show or hide chat window
  showChatWindow = () => {
    if (!this.state.chatScreenFlag && !this.state.customerId) {
      this.initiateChat();
    }
    this.setState({
      chatScreenFlag: !this.state.chatScreenFlag,
    });
  };
  closeChatWindow = () => {
    disconnectSocket();
    this.setState({
      chatScreenFlag: !this.state.chatScreenFlag,
      customerId: ""
    });
  };

  //speech functionality
  renderSpeech = () => {
    recognition.start();
    recognition.onstart = () =>
      this.setState({
        voiceinputrecording: true,
      });
    recognition.onstop = () =>
      this.setState({
        voiceinputrecording: false,
      });
    recognition.onend = () =>
      this.setState({
        voiceinputrecording: false,
      });
    recognition.onerror = () =>
      this.setState({
        voiceinputrecording: false,
      });
    recognition.onnomatch = () =>
      this.setState({
        voiceinputrecording: false,
      });
    recognition.onresult = (event) =>
      this.setState({
        enteredMessage: this.formatMobileNumber(event.results[0][0].transcript),
        voiceinputrecording: false,
      });
  };

  checkForGoogleAssistantCustomer() {
    if (Platform.OS === "web") {
      let encrypteddata = window.location.search.replace("?data=", "");
      if (!encrypteddata) {
        return;
      }
      let urlData = JSON.parse(decrypt(encrypteddata));
      if (!urlData || !urlData.Id) {
        return;
      }
      this.initiateChat(urlData.Id);
      this.setState({
        chatScreenFlag: true,
      });
    }
  }

  //on screen load method
  componentDidMount() {
    this.checkForGoogleAssistantCustomer();
  }

  //on screen change or refresh or closed
  UNSAFE_componentWillMount() {
    if (global.platform === "ios") {
      this.keyboardWillShowSub = Keyboard.addListener(
        "keyboardWillShow",
        this.keyboardWillShow
      );
      this.keyboardWillHideSub = Keyboard.addListener(
        "keyboardWillHide",
        this.keyboardWillHide
      );
    }
    disconnectSocket();
  }

  keyboardWillShow = (event) => {
    Animated.parallel([
      Animated.timing(this.keyboardHeight, {
        duration: event.duration,
        toValue: event.endCoordinates.height,
      }),
    ]).start();
  };

  keyboardWillHide = (event) => {
    Animated.parallel([
      Animated.timing(this.keyboardHeight, {
        duration: event.duration,
        toValue: 0,
      }),
    ]).start();
  };
  //Called immediately before a component is destroyed
  componentWillUnmount() {
    if (global.platform === "ios") {
      this.keyboardWillShowSub.remove();
      this.keyboardWillHideSub.remove();
    }
  }
  //on enter pressed
  onKeyPressed = async (event) => {
    backSpaceEntered = false;
    switch (event.nativeEvent.key) {
      case "Enter":
        event.preventDefault();
        this.sendMessageFromInput();
        break;
      case "Backspace":
        backSpaceEntered = true;
        break;
    }
    if (Platform.OS === "web" && deviceWidth >= 1200) {
      this.inputTextFocus.focus();
    }
  };

  //format mobile number
  formatMobileNumber(value) {
    if (this.state.isFormatMobileNumber && !backSpaceEntered) {
      const number = value.replace("+44-", "").replace(/[^0-9]/g, "");
      value = `+44-${number.substring(0, 4)}${
        number.length >= 4 ? "-" : ""
      }${number.substring(4, 10)}`;
    }
    return value;
  }
  // onchange textinput
  onInputChange = (text) => {
    const inputMsg = this.formatMobileNumber(text);
    this.setState({ enteredMessage: inputMsg });
  };
  //render ui
  render() {
    const resChatcontainer = `chatcontainer_${this.props.measure}`;

    return (
      <ImageBackground
        style={styles.container}
        source={require("../../../assets/images/background.jpg")}
      >
        {this.state.showTerms && (
          <TermsModel
            updateSentMessage={this.updateSentMessage}
            customerId={this.state.customerId}
            hideTerms={() =>
              this.setState({
                showTerms: false,
              })
            }
          />
        )}
        <Image
          style={styles.logo}
          source={require("../../../assets/images/logo.png")}
        ></Image>
        <SafeAreaView style={{ flex: 1 }}>
          <View style={styles.container}>
            {!this.state.chatScreenFlag && (
              <View style={styles.homeChatIconView}>
                <View style={styles.botavatarview}>
                  <TouchableOpacity onPress={this.showChatWindow}>
                    <Image
                      style={styles.chevronLeft}
                      source={require("../../../assets/images/chevronLeft.png")}
                    ></Image>
                    <View style={chatstyles.avatarImageView}>
                      <Image
                        style={styles.botavatar}
                        source={require("../../../assets/images/botavatar.png")}
                      ></Image>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            )}
            {this.state.chatScreenFlag && (
              <View style={[styles.chatcontainer, styles[resChatcontainer]]}>
                <LinearGradient
                  start={[0.0, 0.5]}
                  end={[1.0, 0.5]}
                  colors={["#d15a5e", "#f19058"]}
                  style={styles.chatHeaderBox}
                >
                  <View style={styles.chattitle}>
                    <View style={styles.chatHeader}>
                      <View style={styles.flexRow}>
                        <Image
                          style={styles.botavatarHeader}
                          source={require("../../../assets/images/botavatar.png")}
                        ></Image>
                        <Text style={styles.titletext}>HIFFI</Text>
                      </View>
                      <View style={[styles.flexRow, styles.margin0]}>
                        <View style={styles.reload}>
                          <TouchableOpacity
                            onPress={() => this.initiateChat()}
                            disabled={this.state.restartchatbtnenabled}
                          >
                            <Image
                              style={styles.reloadImage}
                              source={require("../../../assets/images/reload.png")}
                            ></Image>
                          </TouchableOpacity>
                        </View>
                        <View style={styles.closeIconView}>
                          <TouchableOpacity onPress={this.closeChatWindow}>
                            <Image
                              style={styles.closeImage}
                              source={require("../../../assets/images/close.png")}
                            ></Image>
                          </TouchableOpacity>
                        </View>
                      </View>
                    </View>
                  </View>
                </LinearGradient>

                <TouchableOpacity
                  style={styles.sidePull}
                  onPress={this.showChatWindow}
                >
                  <View>
                    <Image
                      style={styles.reloadImage}
                      source={require("../../../assets/images/chevron-left.png")}
                    ></Image>
                  </View>
                </TouchableOpacity>

                <Animated.View
                  style={[
                    { paddingBottom: this.keyboardHeight },
                    styles.chatMessageBox,
                  ]}
                >
                  <ChatContainer
                    loginType="customer"
                    messages={this.state.messages}
                    isAgentTyping={this.state.isAgentTyping}
                    isAgentConnected={this.state.isAgentConnected}
                    updateSentMessage={this.updateSentMessage}
                    disableOptions={this.state.disableOptions}
                    customerId={this.state.customerId}
                    initiateChat={() => this.initiateChat()}
                    showTerms={() =>
                      this.setState({
                        showTerms: true,
                      })
                    }
                  />

                  <View style={styles.chatfooter}>
                    <TextInput
                      ref={(input) => {
                        this.inputTextFocus = input;
                      }}
                      onKeyPress={(e) => this.onKeyPressed(e)}
                      placeholder={TYPE_PLACEHOLDER}
                      style={
                        global.platform === "web"
                          ? [styles.chatinput, { outline: "none" }]
                          : [styles.chatinput]
                      }
                      value={this.state.enteredMessage}
                      multileditable={true}
                      multiline={true}
                      onChangeText={(text) => this.onInputChange(text)}
                      disabled={this.state.inputTextDisabled}
                      editable={!this.state.inputTextDisabled}
                    />
                    {speachrecognitionflag && (
                      <TouchableOpacity
                        onPress={this.renderSpeech}
                        disabled={
                          this.state.voiceinputrecording ||
                          this.state.inputTextDisabled
                        }
                        style={[
                          chatstyles.voice,
                          this.state.inputTextDisabled
                            ? styles.disabledOpacity
                            : null,
                        ]}
                      >
                        <Image
                          style={
                            this.state.voiceinputrecording
                              ? styles.chatvoiceinputrecording
                              : styles.chatvoiceinput
                          }
                          source={require("../../../assets/images/voiceinputicon.png")}
                        ></Image>
                      </TouchableOpacity>
                    )}
                    <TouchableOpacity
                      style={
                        this.state.inputTextDisabled
                          ? styles.disabledOpacity
                          : null
                      }
                      disabled={this.state.inputTextDisabled}
                      onPress={this.sendMessageFromInput}
                    >
                      <Image
                        style={styles.chatsubmit}
                        source={require("../../../assets/images/send.png")}
                      ></Image>
                    </TouchableOpacity>
                  </View>
                </Animated.View>
              </View>
            )}
          </View>
        </SafeAreaView>
      </ImageBackground>
    );
  }
}

export default HocComponent(Home);
